var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAspNet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166,
    height: 94,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9972467%",
    y1: "-19.5160457%",
    x2: "49.9972467%",
    y2: "129.625092%",
    id: "A"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0994dc",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cef5",
    offset: "35.000601%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66cef5",
    offset: "35.000601%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#127bca",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0007616%",
    y1: "-19.5161868%",
    x2: "50.0007616%",
    y2: "129.624154%",
    id: "B"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e76bc",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "36.0001%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "36.0001%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00adef",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9991979%",
    y1: "110.921751%",
    x2: "49.9991979%",
    y2: "-6.21395776%",
    id: "C"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c63b7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    stopOpacity: 0.42,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0009899%",
    y1: "-19.5149993%",
    x2: "50.0009899%",
    y2: "129.627315%",
    id: "D"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#166ab8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "39.999399%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36aee8",
    offset: "39.999399%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "84.616101%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0798dd",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9985422%",
    y1: "-19.5211325%",
    x2: "49.9985422%",
    y2: "129.626892%",
    id: "E"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#124379",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1487cb",
    offset: "38.9999%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1487cb",
    offset: "38.9999%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "78.022802%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "78.022802%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165197",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.000304652977%",
    y1: "50.000544%",
    x2: "100.000291%",
    y2: "50.000544%",
    id: "F"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33bdf2",
    stopOpacity: 0.698,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1dacd8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0095709%",
    y1: "94.6864084%",
    x2: "50.0095709%",
    y2: "-3.02458407%",
    id: "G"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#136ab4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59caf5",
    stopOpacity: 0.55,
    offset: "60.000002%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59caf5",
    stopOpacity: 0.235,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.000760861053%",
    y1: "49.999714%",
    x2: "99.9992241%",
    y2: "49.999714%",
    id: "H"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    stopOpacity: 0.247,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9983236%",
    y1: "124.313712%",
    x2: "49.9983236%",
    y2: "-9.42137278%",
    id: "I"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#318ed5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38a7e4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.99857%",
    y1: "91.1999524%",
    x2: "49.99857%",
    y2: "-76.7854074%",
    id: "J"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    stopOpacity: 0.55,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0000694%",
    y1: "100.01049%",
    x2: "50.0000694%",
    y2: "0.0101898204%",
    id: "K"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1959a6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ec5ea",
    offset: "91.758698%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7ec5ea",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.2883275%",
    y1: "94.5677442%",
    x2: "43.7813065%",
    y2: "5.75513731%",
    id: "L"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#165096",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0d82ca",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9946843%",
    y1: "76.9980959%",
    x2: "49.9946843%",
    y2: "-3.29893613%",
    id: "M"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05a1e6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0495d6",
    offset: "87.362701%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0495d6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.9813836%",
    y1: "-4.16143813%",
    x2: "43.8327902%",
    y2: "105.843625%",
    id: "N"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38a7e4",
    stopOpacity: 0.33,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "96.153301%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "96.153301%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0e88d3",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.016714%",
    y1: "-0.295776148%",
    x2: "50.016714%",
    y2: "101.881944%",
    id: "O"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#168cd4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1c87cc",
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#154b8d",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.6738062%",
    y1: "52.6631814%",
    x2: "87.8125992%",
    y2: "48.8044437%",
    id: "P"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97d6ee",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55c1ea",
    offset: "70.329303%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55c1ea",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "6.89015912%",
    y1: "46.5106927%",
    x2: "75.7828966%",
    y2: "55.3314749%",
    id: "Q"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7accec",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3fb7ed",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9966533%",
    y1: "6.36281892%",
    x2: "49.9966533%",
    y2: "127.96135%",
    id: "R"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1da7e7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37abe7",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.527 39.2h-.593v1.842h-.242V39.2h-.595v-.22h1.43v.22zm2.43 1.843h-.24V39.66l.02-.4-.064.2-.702 1.583h-.118l-.704-1.57a1.14 1.14 0 0 1-.063-.213h-.008a4.61 4.61 0 0 1 .011.403v1.38h-.23v-2.06h.32l.633 1.44a1.87 1.87 0 0 1 .093.247h.01l.1-.254.645-1.432h.304v2.06h-.002zm-1.878 7.654c0-.112-.03-.193-.094-.245-.07-.056-.192-.087-.36-.087h-.243v.668h.293c.27 0 .405-.112.405-.336zm.38 1.392h-.334l-.213-.47c-.108-.235-.224-.353-.35-.353h-.18v.823h-.275v-1.96h.55c.245 0 .43.053.556.164a.47.47 0 0 1 .161.369.48.48 0 0 1-.132.342.66.66 0 0 1-.366.193v.008c.1.026.218.146.324.362l.258.52zm.6-.96a1.32 1.32 0 0 0-.394-.968c-.262-.268-.584-.387-.963-.387-.4 0-.716.13-.974.4a1.32 1.32 0 0 0-.386.966c0 .4.134.717.4.977s.583.388.96.388a1.31 1.31 0 0 0 .961-.393c.264-.26.396-.584.396-.972zm.185-.008c0 .432-.15.795-.447 1.087s-.665.44-1.103.44-.807-.144-1.098-.428-.436-.65-.436-1.088a1.46 1.46 0 0 1 .443-1.086c.295-.286.664-.443 1.104-.443.43 0 .793.14 1.086.423a1.45 1.45 0 0 1 .451 1.094zM65.4 54.58h-.95v-5.43c0-.43.028-.95.08-1.567h-.02c-.1.36-.17.622-.242.783l-2.76 6.214h-.462L58.27 48.4c-.078-.172-.16-.45-.242-.828h-.02c.03.324.045.85.045 1.578v5.42h-.915v-8.087H58.4l2.482 5.64a7.29 7.29 0 0 1 .367.968h.04l.387-.992 2.536-5.615H65.4l.001 8.087zm2.92 0h-.923v-5.775h.923v5.775zm.16-7.845a.58.58 0 0 1-.18.43c-.12.118-.26.175-.43.175s-.308-.056-.426-.17-.176-.258-.176-.435a.57.57 0 0 1 .176-.425c.118-.115.26-.17.426-.17s.314.056.43.17a.57.57 0 0 1 .179.425zm5.605 7.577c-.443.272-.972.407-1.583.407-.828 0-1.495-.275-2.005-.824-.495-.533-.744-1.22-.744-2.064 0-.946.27-1.712.817-2.294s1.273-.874 2.2-.874a2.95 2.95 0 0 1 1.337.293v.95a2.34 2.34 0 0 0-1.376-.453 1.85 1.85 0 0 0-1.439.615c-.386.42-.582.98-.582 1.68 0 .672.18 1.203.534 1.596s.83.586 1.43.586c.505 0 .978-.166 1.42-.496v.878zm4.413-4.57c-.163-.125-.397-.186-.706-.186-.376 0-.7.168-.947.507-.3.38-.435.903-.435 1.573v2.944h-.925v-5.775h.925v1.2h.022c.136-.422.346-.746.626-.976.262-.2.56-.316.885-.316.246 0 .43.027.554.08v.96zm5.154 1.96c0-.74-.167-1.304-.5-1.7-.324-.372-.777-.558-1.36-.558-.575 0-1.036.188-1.38.565-.365.402-.547.97-.547 1.707 0 .7.173 1.233.523 1.62s.817.584 1.404.584c.608 0 1.074-.198 1.392-.592.313-.385.47-.93.47-1.636m.948-.033c0 .92-.26 1.66-.778 2.213s-1.22.834-2.1.834c-.867 0-1.557-.278-2.064-.834-.496-.536-.745-1.244-.745-2.125 0-1.005.28-1.78.847-2.33.522-.5 1.22-.767 2.097-.767.862 0 1.535.268 2.02.8s.724 1.27.724 2.207m4.584 1.366a1.5 1.5 0 0 1-.531 1.177c-.386.338-.917.507-1.585.507-.547 0-1.026-.114-1.433-.348v-.994c.453.368.953.553 1.502.553.732 0 1.1-.27 1.1-.807a.71.71 0 0 0-.243-.557c-.163-.144-.478-.324-.948-.53-.484-.212-.828-.43-1.032-.655-.244-.267-.367-.615-.367-1.043a1.5 1.5 0 0 1 .57-1.196c.378-.318.868-.478 1.467-.478a2.89 2.89 0 0 1 1.235.27v.93a2.18 2.18 0 0 0-1.311-.412c-.306 0-.552.076-.735.225a.72.72 0 0 0-.278.582c0 .256.078.455.232.597.137.132.428.292.867.48.493.207.85.42 1.067.64.282.277.424.63.424 1.06m5.65-1.332c0-.74-.167-1.304-.502-1.7-.323-.372-.777-.558-1.36-.558-.575 0-1.036.188-1.383.565-.364.402-.545.97-.545 1.707 0 .7.173 1.233.52 1.62s.82.584 1.408.584c.6 0 1.073-.198 1.392-.592.313-.385.47-.93.47-1.636m.95-.033c0 .92-.262 1.66-.78 2.213s-1.218.834-2.098.834c-.868 0-1.558-.278-2.065-.834-.496-.536-.745-1.244-.745-2.125 0-1.005.284-1.78.846-2.33.522-.5 1.222-.767 2.1-.767.862 0 1.534.268 2.018.8s.727 1.27.727 2.207m4.073-4.826c-.182-.1-.384-.152-.614-.152-.648 0-.97.408-.97 1.224v.9h1.354v.783H98.27v4.992h-.926v-4.992h-.983v-.783h.983v-.936c0-.636.195-1.134.6-1.494.34-.312.755-.467 1.248-.467.286 0 .508.034.67.1v.834zm3.65 7.678c-.218.125-.5.187-.87.187-1.008 0-1.512-.568-1.512-1.704v-3.416h-1v-.784h1v-1.4l.927-.3V48.8h1.455v.784h-1.455v3.26c0 .387.063.664.196.825s.352.247.66.247a.98.98 0 0 0 .598-.186v.788zM53.5 77.118c0 .452-.162.844-.488 1.175s-.72.495-1.184.495a1.54 1.54 0 0 1-1.154-.495 1.64 1.64 0 0 1-.473-1.175 1.63 1.63 0 0 1 .473-1.183c.316-.326.7-.488 1.154-.488a1.6 1.6 0 0 1 1.184.494c.326.33.488.723.488 1.177m20.707 1.33H71.2l-10.948-16.9c-.256-.407-.476-.848-.664-1.33h-.1c.078.452.118 1.424.118 2.912v15.32H57.13V57.245h3.227l10.62 16.633.858 1.417h.06c-.098-.6-.15-1.65-.15-3.117V57.245h2.47v21.202zm15.94 0H78.914V57.245H89.67v2.247H81.4v7.053h7.664v2.248H81.4V76.2h8.76v2.248zM107.2 59.492h-6.1v18.956h-2.485V59.492h-6.122v-2.248H107.2z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.374 20.624c2.4 7.33 3.307 20.4 10.32 20.4.534 0 1.074-.052 1.615-.155-6.376-1.486-7.132-14.422-11.022-21.12-.305.277-.608.566-.914.867",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.288 19.757c3.89 6.7 4.646 19.635 11.022 21.12a10.15 10.15 0 0 0 1.506-.407C81.093 37.67 79.51 25.107 75.093 19.06a27.53 27.53 0 0 0-.805.698",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.894 15.773a8.67 8.67 0 0 0-1.616.155c-1.42.267-2.86.878-4.314 1.803.397.392.775.84 1.13 1.33 1.478-1.226 2.947-2.132 4.4-2.677.55-.203 1.096-.356 1.645-.457a5.07 5.07 0 0 0-1.254-.153",
    fill: "#14559a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.284 37.888l1.76-1.542c-2.437-7.297-3.31-20.563-10.373-20.563-.505 0-1.015.047-1.523.14 6.434 1.6 7.258 15.6 10.136 21.963",
    fill: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.148 15.926c-.396-.1-.813-.153-1.254-.153l2.778.01a8.27 8.27 0 0 0-1.523.142",
    fill: "#3092c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.16 39.438a10.45 10.45 0 0 1-.796-.86c-1.188.84-2.372 1.478-3.548 1.894.418.204.857.356 1.323.45a5.61 5.61 0 0 0 1.127.111c1.32 0 2.363-.156 3.252-.582-.49-.264-.938-.607-1.357-1.013",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.503 16.384c5.763 3.013 6.264 16.655 10.862 22.194a19.52 19.52 0 0 0 .918-.69c-2.878-6.373-3.7-20.365-10.134-21.963-.55.103-1.097.255-1.646.46",
    fill: "url(#D)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.093 19.06c4.418 6.048 6 18.61 11.723 21.412 1.176-.415 2.36-1.053 3.548-1.894-4.598-5.54-5.1-19.182-10.862-22.194-1.463.543-2.932 1.45-4.4 2.676",
    fill: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.547 20.447c-.693 1.565-1.4 3.622-2.255 6.308 1.7-2.395 3.396-4.46 5.082-6.13a18.41 18.41 0 0 0-.75-1.958 25.32 25.32 0 0 0-2.076 1.781",
    fill: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.238 18.215l-.613.45a18.44 18.44 0 0 1 .749 1.958l.914-.867c-.326-.56-.673-1.078-1.05-1.543",
    fill: "#2b74b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.963 17.73l-.726.484c.377.464.724.982 1.05 1.544l.805-.7c-.355-.49-.733-.937-1.13-1.33",
    fill: "#125a9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27 15.215C110 27.778 103.203 37.868 97.496 40.412l-.32.132c-.014.008-.027.01-.038.015-.03.012-.058.02-.088.033-.014.008-.027.01-.04.016-.048.017-.095.032-.142.05-.02.008-.04.014-.06.02s-.046.016-.07.023-.044.015-.07.024-.042.012-.06.02c-.042.012-.08.022-.122.037-.017 0-.033.01-.05.014-.026.008-.055.015-.082.022-.02.008-.035.01-.056.015-.03.008-.06.016-.1.023l-.11.024c.258.095.527.143.817.143 5.412 0 10.868-9.693 19.896-25.813h-3.545l.001.003z",
    fill: "url(#G)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.117 16.283c.014-.008.02-.008.023-.017.037-.01.065-.022.095-.033.025-.008.032-.017.04-.018l.094-.033c.077-.02.143-.048.213-.073.01 0 .02-.008.03-.008l.09-.027c.014-.008.028-.008.04-.013l.1-.027c.013 0 .025-.008.034-.01l.298-.077c.014 0 .026-.008.04-.01a.57.57 0 0 1 .087-.017c.013-.008.028-.008.043-.013.03-.008.057-.01.088-.016h.02l.18-.033h.036c.03-.008.055-.01.083-.015.016 0 .032-.008.047-.008.027 0 .054-.008.08-.012.014 0 .028 0 .044-.008l.195-.017-.576-.03c-6.094 0-14.49 11.302-18.274 25.94h.73c1.21-2.158 2.298-4.2 3.292-6.115 2.65-10.367 8.045-17.438 12.838-19.31",
    fill: "url(#H)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0d82ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.547 20.447a25.31 25.31 0 0 1 2.076-1.781l-.495-.955c-.558.676-1.067 1.568-1.582 2.737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.048 16.37c.398.334.755.793 1.08 1.343l.315-.352a6.11 6.11 0 0 0-1.473-1.03.67.67 0 0 0 .065.031"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M54.28 35.594c5.557-10.703 8.2-17.477 12.838-19.31-4.792 1.874-10.19 8.945-12.838 19.31",
    fill: "url(#I)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.443 17.36l-.315.352c.174.292.337.6.496.955l.613-.45a8.34 8.34 0 0 0-.794-.856",
    fill: "#127bca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.802 41.66c-.034.008-.07.008-.1.012-.048 0-.078.008-.105.008l-.218.014h-.02c5.625-.157 8.196-2.972 9.47-7.054l2.464-7.9c-2.356 3.314-4.722 7.265-7.102 11.69-1.147 2.133-2.892 3.024-4.388 3.215",
    fill: "url(#J)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.802 41.658c1.496-.19 3.24-1.08 4.388-3.215 2.38-4.425 4.747-8.377 7.1-11.69.856-2.686 1.563-4.742 2.256-6.308-4.69 4.463-9.4 11.885-13.745 21.21",
    fill: "url(#K)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.28 35.594l-3.292 6.115h2.12c.28-2.143.68-4.186 1.172-6.114",
    fill: "#05a1e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.913 15.82c-.017 0-.03.008-.045.008-.026.008-.052.008-.08.01-.016 0-.03 0-.047.008-.03.008-.056.01-.083.015-.013 0-.026 0-.036.008l-.18.032h-.02a.71.71 0 0 1-.088.017c-.015.008-.03.008-.044.012-.03.008-.058.012-.086.017-.015.008-.027.008-.04.01l-.298.077c-.01 0-.02.008-.034.01l-.1.027c-.013.008-.028.008-.04.012l-.09.027c-.012 0-.02.008-.032.008l-.207.073-.094.033c-.013.008-.025.01-.04.016-.03.01-.06.02-.088.033-.01.008-.02.01-.03.014-4.647 1.834-7.28 8.608-12.838 19.31a51.55 51.55 0 0 0-1.172 6.114h.298l2.39-.008h.582c.066-.008.135-.008.204-.014h.013c.03 0 .058-.008.086-.008h.02c.03 0 .066-.008.1-.012 4.344-9.327 9.054-16.748 13.745-21.21.516-1.168 1.024-2.06 1.58-2.735-.325-.55-.682-1-1.08-1.344l-.012-.008c-.023-.01-.044-.02-.066-.032s-.042-.02-.065-.033a.71.71 0 0 1-.064-.031c-.028-.008-.05-.02-.075-.032s-.04-.017-.06-.026c-.042-.016-.083-.033-.123-.05-.018-.008-.035-.013-.052-.02a1.75 1.75 0 0 1-.092-.037c-.015-.008-.032-.01-.05-.016l-.127-.044h-.01c-.05-.016-.097-.028-.148-.042-.012-.008-.02-.008-.033-.01l-.124-.035c-.01 0-.02-.008-.03-.008-.1-.027-.204-.048-.31-.068-.01 0-.02-.008-.032-.008a1.83 1.83 0 0 0-.134-.021c-.01-.008-.017-.008-.027-.008-.054-.008-.106-.015-.158-.02h-.028c-.043-.008-.082-.01-.122-.014-.067.008-.132.012-.195.018",
    fill: "url(#L)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.54 22.17l-2.69 8.57c2.934-4.035 5.824-9.112 8.576-14.97-3.2 1.008-4.923 3.314-5.887 6.398",
    fill: "url(#M)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.944 40.198l-.447.214c5.707-2.544 12.514-12.634 15.774-25.197h-.66c-7.488 13.37-9.896 22.32-14.666 24.983",
    fill: "url(#N)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.217 39.075c1.242-1.515 2.253-4.1 3.634-8.334-1.593 2.187-3.196 4.066-4.8 5.6.342 1.062.726 1.988 1.164 2.734",
    fill: "#079ae1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.217 39.075c-.423.516-.87.908-1.368 1.2l-.332.178a4.81 4.81 0 0 0 1.741.549l.285.025h.017c.044 0 .1 0 .137.008h.464c.017 0 .035 0 .052-.008.033 0 .07 0 .103-.008h.05c.035 0 .074-.008.11-.012.02 0 .032-.008.043-.008.04-.008.08-.012.12-.018h.035l.134-.022h.008l.28-.056c-.736-.27-1.353-.905-1.884-1.8",
    fill: "#1969bc"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1e5cb3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.695 41.034c.534 0 1.074-.052 1.615-.156a10.01 10.01 0 0 0 1.506-.406c.42.204.857.356 1.322.45a5.62 5.62 0 0 0 1.128.111h-5.57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.267 41.034c1.32 0 2.363-.156 3.25-.582a4.81 4.81 0 0 0 1.741.549l.285.025h.017c.044 0 .1 0 .137.008h.16-5.595.004z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.86 41.034h.305c.018 0 .035 0 .052-.008.033 0 .07 0 .104-.008h.05c.035 0 .074-.008.1-.012.02 0 .032-.008.043-.008.04-.008.08-.012.12-.018.013 0 .023 0 .037-.008l.134-.02h.008l.28-.056c.258.095.527.143.817.143l-2.057.008-.002-.01z",
    fill: "#1d60b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.045 36.354l-1.76 1.533-.92.7a10.44 10.44 0 0 0 .796.86c.42.406.868.75 1.357 1.013l.33-.178c.5-.29.946-.684 1.37-1.2-.438-.747-.822-1.672-1.172-2.72",
    fill: "#175fab"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.518 15.215h-3.324l-.527.026-.245.524c-2.752 5.858-5.642 10.934-8.575 14.97-1.38 4.244-2.392 6.82-3.634 8.334.53.905 1.148 1.542 1.883 1.81.02-.008.04-.008.058-.013h.012c.013 0 .027-.008.04-.008.03-.008.062-.014.092-.023.02-.008.035-.01.055-.015.028-.008.057-.015.082-.02.017-.008.034-.01.05-.015.043-.014.08-.024.122-.037.02-.008.04-.015.06-.02s.047-.015.07-.025.05-.013.07-.022.04-.014.058-.02c.048-.017.095-.032.143-.05.013 0 .026-.012.04-.015.03-.012.06-.02.088-.034.01-.008.024-.01.037-.014l.308-.132h.01a8.75 8.75 0 0 0 .446-.214c4.77-2.664 7.18-11.614 14.667-24.983h-2.09l.002-.001z",
    fill: "url(#O)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.108 15.802c.012 0 .023 0 .034.008.03 0 .058 0 .087.01h.03l.158.02c.01 0 .018 0 .027.008l.134.022c.01 0 .023.008.033.008l.308.068c.01 0 .02.008.028.008l.124.035c.013 0 .022.008.034.01l.147.042.14.052c.017.008.033.012.05.016l.092.038c.017 0 .034.012.052.018l.122.05.06.026a.53.53 0 0 0 .074.032l.065.03.065.033a6.14 6.14 0 0 1 1.473 1.03 4.78 4.78 0 0 1 .522-.474 5.75 5.75 0 0 0-3.406-1.102l-.452.02",
    fill: "#7dcbec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.443 17.36c.277.258.543.546.794.856l.726-.484c-.317-.317-.65-.6-1-.846-.18.14-.354.3-.52.474",
    fill: "#5ec5ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.016 1.97l.452.018c1.294 0 2.416-.4 3.406-1.1C5.918 1.712 7.18 2 8.935 2H.44c.196 0 .387-.012.576-.03",
    transform: "matrix(1 0 0 -1 68.091859 17.772736)",
    fill: "url(#P)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.654 2C2.9 2 1.637 1.712.592.888c.347-.245.68-.53.998-.846 1.455.924 2.895 1.536 4.316 1.804a8.76 8.76 0 0 0 1.615.154H4.654z",
    transform: "matrix(1 0 0 -1 72.373198 17.772736)",
    fill: "url(#Q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.85 30.743l2.7-8.573c.965-3.085 2.675-5.392 5.885-6.398l.247-.524c-5.233.313-7.68 2.974-8.9 6.914C95.6 29.04 94.307 33.5 93.05 36.34c1.603-1.532 3.207-3.413 4.8-5.597",
    fill: "url(#R)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAspNet);
export default __webpack_public_path__ + "static/media/AspNET.233f852450a5bd0b27a9e4689a5b9216.svg";
export { ForwardRef as ReactComponent };